/* global postlove */
/* eslint-disable */

var loc;

function calcSuggRetAge(age, serviceyr, program, policefire, cretage) {
    var calcBase = ER[policefire][program];
    var minRetAge = Math.max(age + calcBase.min_svc_yr - serviceyr, calcBase.min_ret_age);
    //custAgeMinBound = Math.max(Math.min(minRetAge, calcBase.nra), age + calcBase.min_proj_yr);
    custAgeMaxBound = Math.max(calcBase.max_custom_age, age + calcBase.min_proj_yr);
    suggRetAge = Math.max(Math.min(minRetAge, calcBase.target_sugg_age), age + calcBase.min_proj_yr );
    //console.log("Suggeted age: " + Math.max(Math.min(minRetAge, calcBase.target_sugg_age))  + " OR " + age + calcBase.min_proj_yr + " = " + suggRetAge);

    //var top_message = '';

    if (cretage) {
        //Check if custom age is out of bound
        if (cretage < suggRetAge || cretage > custAgeMaxBound ) {
            //var sbj_program_text = ["OPSRP","Tier 1", "Tier 2"];
        }
    }

    jQuery('#suggest-number').html(suggRetAge);
    //console.log('suggRetAge:'+suggRetAge);
    //jQuery('#retire-age').val(suggRetAge);

    var final_year = jQuery('#retire-age').val() - age + serviceyr;
    jQuery('#final-year-service').val(final_year);
}

function triggerSuggRetAge() {
    var age = parseFloat(jQuery('#current-age').val());
    var serviceyr = parseFloat(jQuery('#years-of-service').val());
    var program = jQuery('#pers-member-type').val();
    //var policefire = jQuery('input[name="policefire"]:checked').val();
    var policefire = 0;
    var cretage = jQuery('#retire-age').val();
    if (age && serviceyr && program  && age > serviceyr) {
        calcSuggRetAge(age, serviceyr, parseInt(program), parseInt(policefire), parseFloat(cretage));
    }
    else {
        jQuery('#suggest-number').html('--');
    }
}

function calcEstimatedIAP() {
    curAge = parseInt(jQuery('#current-age').val());
    var yearosServ  =  parseInt(jQuery('#years-of-service').val());
    var iapBalance = false;

    var historicalIAP = curAge + 'w' + yearosServ;

    $.ajax ({
        method: "POST",
        url: postlove.ajax_url,
        type: 'post',
        data: {type: 'hisIAP', key: historicalIAP, action: 'post_love_add_love', src: loc},
        dataType:"html",
        success: function(data) {
            //alert('ajax jalan');
            if(data !== -1) {
                var sal = clean_number_format(jQuery('#salary').val());

                if($('#salary-switch').is(':checked')) {
                    sal = sal*26;
                }
                var curSalary = clean_number_format(sal);

                iapBalance = parseFloat(data);
                var estIAP = curSalary * iapBalance;
                //console.log('woi', estIAP, curSalary, iapBalance, isNaN(estIAP));

                if(isNaN(estIAP)) {
                    jQuery('#iap-balance').val('');
                } else {
                    jQuery('#iap-balance').val(money_format(estIAP));
                }

            } else {
                jQuery('#iap-balance').val('not found');
            }
        },
        error: function (data) {
            console.log( data );
        },
    });
}

function calcSidebar() {
    var curAge = parseInt(jQuery('#current-age').val());
    var yearosServ  = parseInt(jQuery('#years-of-service').val());
    var type = jQuery('#pers-member-type option:selected').text();
    retire_age = parseInt(jQuery('#retire-age').val());
    retire_eli = curAge+'w'+yearosServ;

    //Retire Eligible
    if(type !== 'Choose...' && isNaN(yearosServ) == false) {
        jQuery('#retire-eli').val(retire_eli+type);
    }

    //Final Yrs of Service
    finalYrServ = retire_age-curAge+yearosServ;
    if(isNaN(finalYrServ) == false) {
        jQuery('#final-year-service').val(finalYrServ);
    } else {
        jQuery('#final-year-service').val('');
    }
    //console.log('widiw', retire_age, curAge, yearosServ);

    //Last Yr Salary
    curSal = clean_number_format(jQuery("#salary").val());
    if($('#salary-switch').is(':checked')) {
        curSal = curSal*26;
    }

    $.ajax ({
        method: "POST",
        url: postlove.ajax_url,
        type: 'post',
        data: {type: 'paygrowth', finalYear: parseInt(jQuery('#final-year-service').val()), yearofS: yearosServ, action: 'post_love_add_love', src: loc},
        dataType:"json",
        success: function(data) {
            //alert(data.param_2, data.param_3);

            var param_2 = parseFloat(data.param_2);
            var param_3 = parseFloat(data.param_3);
            lastYrSal = curSal*(param_2/param_3);
            var lastYrSal_money = money_format(lastYrSal);
            var lastYrSal_money2 = money_format(lastYrSal/12);
            if(isNaN(lastYrSal) == false) {
                jQuery('#salary-last-year').val(lastYrSal_money);
                jQuery('#salary-last-year-pyp').val(lastYrSal_money2);
            }else {
                jQuery('#salary-last-year').val('');
                jQuery('#salary-last-year-pyp').val('');
            }
            //console.log( 'lastyear sal:' + lastYrSal, 'curSal:' + curSal, param_2, param_3 );
            calcFinalAvgSal();
        },
        error: function (data) {
            console.log( 'error 192:' + data );
        },
    });

    //Pension Factor
    //=VLOOKUP(PensionTier,Benefits!$A$1:$B$4,2,FALSE)
    type = jQuery('#pers-member-type option:selected').text();

    if (type == 'Tier 1') {
        pension_factor = 1.67;
    } else if (type == 'Tier 2') {
        pension_factor = 1.67;
    } else {
        pension_factor = 1.5;
    }
    jQuery('#pension').val(pension_factor + '%');

    //Show vesting warning
    //=IF(FinalYrsOfService<5,"Yes","No")
    if (finalYrServ < 5) {
        jQuery('#vesting-warn').val('Yes');
        jQuery('.vested-note').css('display', 'inline-block');
    } else {
        jQuery('#vesting-warn').val('No');
        jQuery('.vested-note').css('display', 'none');
    }

    //Show retirement
    //=IF(RetirementAge-CurrentAge<0,"Yes","No")
    retire_age = parseInt(jQuery('#retire-age').val());

    var show_retire = retire_age - curAge;
    if (show_retire < 0) {
        jQuery('#show-ret-age').val('Yes');
        alert('Error: Your retirement age must be greater than your current age');
        jQuery('#retire-age').val('');
    } else {
        jQuery('#show-ret-age').val('No');
    }

    //eligible to retire
    //=INDEX(RetireEligible!$E$2:$BH$10711,MATCH(Calculator!Q2,RetireEligible!D2:D10711,0),MATCH(RetirementAge,RetireEligible!E1:BH1,0))
    //console.log(suggRetAge, 'eiyy');
    if(loc == 'calc') {
        if( retire_age >= suggRetAge) {
            jQuery('#retire-eligible-no').val('Yes');
            jQuery('.eligible-note').css('display', 'none');
        } else {
            if(suggRetAge !== 0) {
                jQuery('.eligible-note').show();
            }
            jQuery('#retire-eligible-no').val('No');
        }
    } else {
        if (type == 'Tier 1') {
            if ((yearosServ >= 30) || (curAge >=58)) {
                jQuery('#retire-eligible-no').val('Yes');
                jQuery('.eligible-note').css('display', 'none');
            } else {
                jQuery('.eligible-note').show();
                jQuery('#retire-eligible-no').val('No');
            }
        } else if (type == 'Tier 2') {
            if ((yearosServ >= 30) || (curAge >=60)) {
                jQuery('#retire-eligible-no').val('Yes');
                jQuery('.eligible-note').css('display', 'none');
            } else {
                jQuery('.eligible-note').show();
                jQuery('#retire-eligible-no').val('No');
            }
        } else {
            if (((yearosServ >= 30) && (curAge >=58)) || (curAge >= 65)) {
                jQuery('#retire-eligible-no').val('Yes');
                jQuery('.eligible-note').css('display', 'none');
            } else {
                jQuery('.eligible-note').show();
                jQuery('#retire-eligible-no').val('No');
            }
        }
    }

    //Current - years of service < 16
    //var curYosGap = curAge - yearosServ;
    //console.log(curYosGap);
    //if (curYosGap < 16) {
    //  jQuery('#years-of-service').addClass('is-invalid');
    //} else {
    //  jQuery('#years-of-service').removeClass('is-invalid');
    //}
}

function calcPlannedRetirementYr() {
    var d = new Date();
    var retire_age = $('#retire-age').val();
    var current_age = $('#current-age').val();

    var planretire = d.getFullYear() + (retire_age - current_age);

    $("#plan-retire-year").val(planretire);
}

function calcFieldBottom (){
    //Calculate Bottom
    var curSal = clean_number_format(jQuery("#salary").val());
    var annual_pension = clean_number_format(finalAvgSal)*finalYrServ*pension_factor/100;

    if($('.template-calculator').length) {
        if(isNaN(annual_pension) == false) {
            jQuery('#annual-pension').val(money_format(annual_pension));
            jQuery('#annual-pension-pyp').val(money_format(annual_pension/12));
        } else {
            jQuery('#annual-pension').val('');
            jQuery('#annual-pension-pyp').val('');
        }
    } else if($('.template-calculator-legislation').length) {
        if(isNaN(annual_pension) == false) {
            jQuery('#annual-pension').val(money_format(annual_pension));
            jQuery('#after-annual-pension').val(money_format(annual_pension));

            jQuery('#annual-pension-pyp').val(money_format(annual_pension/12));
            jQuery('#after-annual-pension-pyp').val(money_format(annual_pension/12));

        } else {
            jQuery('#annual-pension').val('');
            jQuery('#after-annual-pension').val('');
            jQuery('#annual-pension-pyp').val('');
            jQuery('#after-annual-pension-pyp').val('');
        }
    }
    console.log('oi', 'finalAvgSal:'+finalAvgSal, 'finalAvgSal:'+finalYrServ, pension_factor/100);

    var inflationRate = 2.5/100;
    var annual_pension_2018 = annual_pension*Math.pow((1/(1+inflationRate)), retire_age-curAge);

    if($('.template-calculator').length) {
        if(isNaN(annual_pension_2018) == false) {
            jQuery('#annual-pension-2018').val(money_format(annual_pension));
            jQuery('#annual-pension-2018-pyp').val(money_format(annual_pension/12));
        } else {
            jQuery('#annual-pension-2018').val('');
            jQuery('#annual-pension-2018-pyp').val('');
        }
    } 
    else if($('.template-calculator-legislation').length) {
        if(isNaN(annual_pension) == false) {
            jQuery('#annual-pension-2018').val(money_format(annual_pension));
            jQuery('#after-annual-pension-2018').val(money_format(annual_pension));
            jQuery('#annual-pension-2018-pyp').val(money_format(annual_pension/12));
            jQuery('#after-annual-pension-2018-pyp').val(money_format(annual_pension/12));
        } else {
            jQuery('#annual-pension-2018').val('');
            jQuery('#after-annual-pension-2018').val('');
            jQuery('#annual-pension-2018-pyp').val('');
            jQuery('#after-annual-pension-2018-pyp').val('');
        }
    }


    console.log('oi2', annual_pension, annual_pension_2018,  inflationRate, retire_age, curAge);

    $.ajax ({
        method: "POST",
        url: postlove.ajax_url,
        type: 'post',
        data: {type: 'retire-iap', retire_age: retire_age, retire_eli: retire_eli, action: 'post_love_add_love', src: loc},
        dataType:"json",
        success: function(data) {
            //console.log(data);
            //alert('ajax jalan');

            var param_2 = parseFloat(data.param_2);
            var param_3 = parseFloat(data.param_3);
            var anticipated_retire = clean_number_format(jQuery('#iap-balance').val());
            var pastiap_growth = anticipated_retire * param_3;
            var newiap_growth = curSal * param_2;
            iap_retire = newiap_growth + pastiap_growth;
            console.log('iap_retire:'+iap_retire, 'cursal:'+curSal, 'param_2:'+param_2, 'param_3:', param_3, 'anticipated_retire:'+anticipated_retire);

            if($('.template-calculator').length) {
                if(isNaN(iap_retire) == false) {
                    jQuery('#retire-iap').val(money_format(iap_retire));
                    //jQuery('#retire-iap-pyp').val(money_format(iap_retire/12));
                } else {
                    jQuery('#retire-iap').val('');
                    //jQuery('#retire-iap-pyp').val('');
                }
            } else if($('.template-calculator-legislation').length) {
                var retire_age = $('#retire-age').val();
                var cont_rate = parseInt($('#future-iap-percent option:selected').val());
                var estIAP = clean_number_format($('#iap-balance').val());
                var yearosServ = parseInt($('#years-of-service').val());

                console.log(cont_rate);

                $.ajax ({
                    method: "POST",
                    url: postlove.ajax_url,
                    type: 'post',
                    data: {type: 'retire_iap_legis', rate:cont_rate, helper: curAge+'w'+yearosServ, retire_age: retire_age, estIap: estIAP, action: 'post_love_add_love', src: loc},
                    dataType:"json",
                    success: function(data) {
                        var param_1 = parseFloat(data.param_1);

                        var param_2 = parseFloat(data.param_2);
                        iap_retire = curSal * param_1 + estIAP * param_2;

                        console.log('3.5 '+'param1' + data.param_1 + '+ param2' + data.param_2);
                        console.log(iap_retire);

                        if(isNaN(iap_retire) == false) {
                            var after_iap_retire;

                            if(pension_factor == 1.5) { //if OPSRP
                                after_iap_retire = (pastiap_growth) + (newiap_growth * 0.875);
                            } else {
                                after_iap_retire = (pastiap_growth) + (newiap_growth * 0.5833);
                            }

                            console.log(pastiap_growth, newiap_growth);

                            jQuery('#retire-iap').val(money_format(iap_retire));
                            jQuery('#after-retire-iap').val(money_format(after_iap_retire));
                            //jQuery('#retire-iap-pyp').val(money_format(iap_retire/12));

                            console.log(iap_retire);
                        } else {
                            jQuery('#retire-iap').val('');
                            jQuery('#after-retire-iap').val('');
                            jQuery('#retire-iap-pyp').val('');
                        }
                    },
                    error: function (data) {
                        console.log( 'error 192:' + data );
                        console.log( data );
                    },
                });

                console.log('333', curAge+'w'+yearosServ);
            }

            var iap_retire_pow = Math.pow((1/(1+inflationRate)), retire_age-curAge); // pengali untuk menghitung inflasi
            var iap_retire_2018 = 0;
            //console.log('iap_retire_2018:', iap_retire_2018, 'iap_retire:', iap_retire, 'inflationRate:', inflationRate, 'retire_age:', retire_age, 'curAge:', curAge);
            //console.log("2018", iap_retire_2018, "normal", iap_retire);
            iap_retire_2018 = (pastiap_growth * iap_retire_pow) + (newiap_growth * iap_retire_pow);
            if($('.template-calculator').length) {
                if(isNaN(iap_retire_2018) == false) {
                    jQuery('#retire-iap-2018').val(money_format(iap_retire_2018));
                    jQuery('#retire-iap-2018-pyp').val(money_format(iap_retire_2018/12));
                } else {
                    jQuery('#retire-iap-2018').val('');
                    jQuery('#retire-iap-2018-pyp').val('');
                }
            } else if($('.template-calculator-legislation').length) {
                if(isNaN(iap_retire_2018) == false) {
                    var after_iap_retire_2018;

                    if(pension_factor == 1.5) { //if OPSRP
                        after_iap_retire_2018 = (pastiap_growth * iap_retire_pow) + (newiap_growth * iap_retire_pow * 0.875);
                    } else {
                        after_iap_retire_2018 = (pastiap_growth * iap_retire_pow) + (newiap_growth * iap_retire_pow * 0.5833);
                    }

                    jQuery('#retire-iap-2018').val(money_format(iap_retire_2018));
                    jQuery('#after-retire-iap-2018').val(money_format(after_iap_retire_2018));
                    jQuery('#retire-iap-2018-pyp').val(money_format(iap_retire_2018/12));
                } else {
                    jQuery('#retire-iap-2018').val('');
                    jQuery('#after-retire-iap-2018').val('');
                    jQuery('#retire-iap-2018-pyp').val('');
                }
            }
        },
        error: function (data) {
            console.log( 'error 278:' + data );
        },
    });

    calcPlannedRetirementYr();
}

function calcFinalAvgSal() {
    //Final Avg Salary
    //=RetirementSalary*(VLOOKUP(FinalYrsOfService,PayGrowth!$A$1:$D$87,4,FALSE))
    //Final Avf Salary 2019
    //=MIN((195000*((1+InflationRate)^(RetirementAge-CurrentAge))),RetirementSalary*(VLOOKUP(FinalYrsOfService,PayGrowth!$A$1:$D$87,4,FALSE)))

    $.ajax ({
        method: "POST",
        url: postlove.ajax_url,
        type: 'post',
        data: {type: 'finalAvgSal', finalYear: parseInt(jQuery('#final-year-service').val()), action: 'post_love_add_love', src: loc},
        dataType:"json",
        success: function(data) {
            //alert('ajax jalan');

            //console.log('finalAvgSal:'+data.param_2)

            var inflationRate = 2.5/100;
            var param_2 = parseFloat(data.param_2);

            var res1 = lastYrSal*param_2;
            var res2 = 195000*(Math.pow(((1+inflationRate)), retire_age-curAge));

            if (loc == 'calc') {
                finalAvgSal = res1;
            } else {
                if(res1 < res2) {
                    finalAvgSal = res1;
                } else {
                    finalAvgSal = res2;
                }
            }

            console.log('yup', finalAvgSal, lastYrSal, param_2, retire_age, curAge);
            if(isNaN(finalAvgSal) == false) {
                jQuery('#final-avg-sal').val(money_format(finalAvgSal));
                jQuery('#final-avg-sal-pyp').val(money_format(finalAvgSal/12));
            } else {
                jQuery('#final-avg-sal').val('');
                jQuery('#final-avg-sal-pyp').val('');
            }
            calcFieldBottom();
        },
        error: function (data) {
            console.log( 'error 212:' + data );
        },
    });
}

function clean_number_format(num) {
    num = '' + num;
    num = num.toString().replace(/[^0-9.]/g, "");
    var check = num.split('.');
    if(check.length > 1) {
        num = parseFloat(num);
        return num.toFixed(0);
    }
    return parseFloat(num);
}
function money_format(num) {
    num = clean_number_format(num);
    num = '' + num;
    num = num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    return num;
}


if($('.template-calculator').length || $('.template-calculator-legislation').length) {
    var suggRetAge = 0;
    var custAgeMaxBound = 0;

    var finalAvgSal = 0;
    var finalYrServ = 0;
    var iap_retire = 0;
    var pension_factor = 0;
    var lastYrSal = 0;
    var retire_age = parseInt(jQuery('#retire-age').val());
    var curAge = parseInt(jQuery('#current-age').val());
    var retire_eli = 0;
    var curSal = parseInt(jQuery("#salary").val());

    if($('#salary-switch').is(':checked')) {
        curSal = curSal*26;
    }

    var ER =  [ [ { "target_sugg_age": 65, "min_svc_yr": 30, "min_ret_age": 58, "min_proj_yr": 3, "nra": 65, "max_custom_age": 70, "formula": 0.015 },
        { "target_sugg_age": 62, "min_svc_yr": 30, "min_ret_age": 0, "min_proj_yr": 3, "nra": 58, "max_custom_age": 70, "formula": 0.0167 },
        { "target_sugg_age": 62, "min_svc_yr": 30, "min_ret_age": 0, "min_proj_yr": 3, "nra": 60, "max_custom_age": 70, "formula": 0.0167 } ],
        [ { "target_sugg_age": 60, "min_svc_yr": 25, "min_ret_age": 53, "min_proj_yr": 3, "nra": 60, "max_custom_age": 70, "formula": 0.018 },
            { "target_sugg_age": 55, "min_svc_yr": 25, "min_ret_age": 50, "min_proj_yr": 3, "nra": 55, "max_custom_age": 70, "formula": 0.02 },
            { "target_sugg_age": 55, "min_svc_yr": 25, "min_ret_age": 50, "min_proj_yr": 3, "nra": 55, "max_custom_age": 70, "formula": 0.02 } ] ];

    //var TT = [ { 10: 1.01, 20: 1.02, 25: 1.03, 30: 1.04 }, { 10: 1.01, 20: 1.025, 25: 1.04 } ]

    $('.options-text').click(function() {
        var val = $(this).index();

        $('.options-text').removeClass('active');
        $(this).addClass('active');

        console.log($(this).attr('class'));

        $('#pers-member-type option').attr('selected', false);

        if(val == 0) {
            $('#pers-member-type option[value=1]').attr('selected', true);
        } else if(val == 1) {
            $('#pers-member-type option[value=2]').attr('selected', true);
        } else {
            $('#pers-member-type option[value=0]').attr('selected', true);
        }
    });

    $('#salary-switch').change(function() {
        if($(this).is(':checked')) {
            $('.handler-switch1').text('PER PAY PERIOD');
        } else {
            $('.handler-switch1').text('ANNUAL');
        }
    });

    $('#inflation-switch').change(function() {
        if($(this).is(':checked')) {
            $('.switch-toggle-content-pension').eq(0).css('display', 'flex');
            $('.switch-toggle-content-pension').eq(1).hide();
            $('.switch-toggle-content-iap-2').show();
            $('.switch-toggle-content-iap').hide();
        } else {
            $('.switch-toggle-content-pension').eq(0).hide();
            $('.switch-toggle-content-pension').eq(1).css('display', 'flex');
            $('.switch-toggle-content-iap-2').hide();
            $('.switch-toggle-content-iap').show();
        }
    });

    /* Prevent submit form */
    $("form").submit(function(e){
        e.preventDefault();
    });

    jQuery('#calculate_now').on('click', function() {
        retire_age = parseInt(jQuery('#retire-age').val());
        curAge = parseInt(jQuery('#current-age').val());

        var show_retire = retire_age - curAge;

        var yearofsrv = parseInt(jQuery('#years-of-service').val());

        var yearofsrv_calc = curAge - yearofsrv;

        if($('.template-calculator').length) {
            loc = 'calc';
        }
        else if($('.template-calculator-legislation').length) {
            loc = 'calclegis';
        }

        //console.log(yearofsrv_calc);
        console.log(loc);

        if (show_retire < 0) {
            jQuery('#show-ret-age').val('Yes');
            alert('Error: Your retirement age must be greater than your current age');
            jQuery('#retire-age').val('');
            jQuery('#retire-age').addClass('is-invalid');
            jQuery('html, body').animate({
                'scrollTop': jQuery('.needs-validation').offset().top - 100,
            }, 500);

        } else if(yearofsrv_calc < 16)  {
            alert('Error: Your approximate years of service cannot exceed your age.');
            jQuery('#years-of-service').val('');
            jQuery('#years-of-service').parent().next().css('display', 'block');
            jQuery('html, body').animate({
                'scrollTop': jQuery('.needs-validation').offset().top - 100,
            }, 500);
        } else if(jQuery('.needs-validation')[0].checkValidity()) {
            jQuery('#retire-age').removeClass('is-invalid');
            jQuery('#years-of-service').parent().next().css('display', 'none');

            triggerSuggRetAge();

            if(jQuery('#iap-balance').hasClass('changed') == false) {
                calcEstimatedIAP();
            }
            calcSidebar();

            jQuery('.bottom-section').show();
            jQuery('html, body').animate({
                'scrollTop': jQuery('.bottom-section').offset().top - 100,
            }, 500);
        } else {
            jQuery('html, body').animate({
                'scrollTop': jQuery('.needs-validation').offset().top - 100,
            }, 500);
        }
    });

    jQuery('#salary').on('change', function() {
        var id = jQuery(this).attr('id');
        var val = jQuery(this).val();
        var money;
        money = money_format(val);
        jQuery('#'+id).val(clean_number_format(val));
        jQuery(this).val(money);
        //triggerSuggRetAge();
        //calcEstimatedIAP();
        //calcSidebar(); //calculate sidebar fields and bottom

    });

    jQuery('#iap-balance').on('change', function() {
        var id = jQuery(this).attr('id');
        var val = jQuery(this).val();
        var money;
        money = money_format(val);
        jQuery('#'+id).val(clean_number_format(val));
        jQuery(this).val(money);

        if(jQuery(this).val() == '' || jQuery(this).val() == '0') {
            jQuery(this).removeClass('changed');
            jQuery(this).val('');
        } else {
            jQuery(this).addClass('changed');
        }
        //triggerSuggRetAge();
        //calcSidebar(); //calculate sidebar fields and bottom
    });

    $('.options-text').click(function() {
        var val = $(this).index();

        if(val == 0) {
            jQuery('.notification-tier12').show();
        } else if(val == 1) {
            jQuery('.notification-tier12').show();
        } else {
            jQuery('.notification-tier12').css('display', 'none');
        }
    });

    jQuery('#pers-member-type').on('change', function() {
        if(jQuery(this).val() == 1) {
            jQuery('.notification-tier12').show();
        } else if(jQuery(this).val() == 2) {
            jQuery('.notification-tier12').show();
        } else {
            jQuery('.notification-tier12').css('display', 'none');
        }

        //triggerSuggRetAge();
        //calcEstimatedIAP();
        //calcSidebar(); //calculate sidebar fields and bottom
    });
}



// WEBPACK FOOTER //
// ./scripts/calculatorFuncs.js